const lookup_prefix = 'ERROR_CODE_';

const ERROR_CODES = require('../client_codes.json').reduce((acc, ec) => {
    acc[`${lookup_prefix}${ec.code}`] = ec.code;
    return acc;
}, {});

module.exports = ERROR_CODES;
